/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Button,
	Center,
	Divider,
	Flex,
	Heading,
	HStack,
	Icon,
	IconButton,
	List,
	ListItem,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Spinner,
	Text,
	VStack,
} from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import { FiUploadCloud } from 'react-icons/fi'
import { MdCheck, MdClose } from 'react-icons/md'
import { useAuthContext } from '../../context/auth.context'
import { useSharedContext } from '../../context/shared.context'
import { useLanguageContext } from '../../context/locale.context'
import { BsImageAlt } from 'react-icons/bs'
import { loadImageBlob } from '../../utils/aws.util'

const encode = data => {
	let str = data.reduce(function (a, b) {
		return a + String.fromCharCode(b)
	}, '')
	return btoa(str).replace(/.{76}(?=.)/g, '$&\n')
}

const ActivityImage = ({ url }) => {
	const [imgData, setImgData] = useState(null)
	const [imgType, setImgType] = useState(null)
	loadImageBlob(url, (data, type) => {
		setImgData(data)
		setImgType(type)
	})
	return (
		<img
			src={
				imgData !== null ? 'data:' + imgType + ';base64,' + encode(imgData) : ''
			}
			alt={'Dashboard'}
			width={300}
			height={300}
		/>
	)
}

const CardDetails = ({ card_data, isOpen, onClose }) => {
	const inputRef = useRef()
	const {
		state: { locale },
	} = useLanguageContext()
	let title = card_data
		.filter(f => f.db_field_name === 'activity_title')
		.reduce((a, s) => s.value, '')
	let a_image = card_data?.[0]?.['activity_image_path']

	return (
		<Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius='md' bg='white' minW='70vw' m='auto' h='600px'>
				<ModalCloseButton />
				<ModalBody p={0} w='100%'>
					<HStack h='full'>
						<Box h='full' w='40%' overflow='auto'>
							<VStack
								py={2}
								h='full'
								justifyContent='center'
								alignItems='center'
							>
								<Heading
									size='md'
									ml={2}
									color='brand.800'
									fontWeight='400'
									mb={3}
									textAlign={'center'}
								>
									{title}
								</Heading>
								<Flex
									w='80%'
									h='60%'
									border='2px'
									borderColor='brand.800'
									borderStyle='dashed'
									borderRadius='10px'
									cursor='pointer'
								>
									<VStack
										justifyContent='center'
										w='100%'
										alignItems='center'
										spacing={3}
									>
										{a_image === '' ? (
											<Icon
												as={BsImageAlt}
												w={20}
												h={20}
												color='brand.800'
												strokeWidth='1px'
											/>
										) : (
											<ActivityImage url={a_image} />
										)}
									</VStack>
								</Flex>
							</VStack>
						</Box>
						<VStack
							h='full'
							borderRightRadius='md'
							flex={1}
							bg='secondary'
							display='flex'
						>
							<VStack w='100%' mx='auto' flex={1} mt={10} alignItems='center'>
								<List
									w='full'
									spacing={3}
									h='496px'
									overflowX={'hidden'}
									overflowY='auto'
								>
									{(card_data || []).map((d, index) => {
										return (
											<>
												<ListItem key={index}>
													<Flex ml={5} spacing={2}>
														<Box ml={2} flex={1}>
															<Text fontSize='16px' fontWeight={'800'}>
																{d.header_name}
															</Text>
															<Text
																onClick={() =>
																	d.db_field_name === 'activity_title'
																		? d?.onClickHandler(d.listItem)
																		: null
																}
																fontSize='14px'
																fontWeight={
																	d.db_field_name === 'activity_title'
																		? '800'
																		: 'normal'
																}
																cursor={
																	d.db_field_name === 'activity_title'
																		? 'pointer'
																		: 'default'
																}
																color={
																	d.db_field_name === 'activity_title'
																		? 'brand.800'
																		: 'inherit'
																}
															>
																{d.value}
															</Text>
														</Box>
													</Flex>
												</ListItem>
												<Divider border='1px' borderColor='white' mt={2} />
											</>
										)
									})}
								</List>
							</VStack>
							<ModalFooter
								w='full'
								py={2}
								alignSelf='flex-end'
								justifySelf='flex-end'
							>
								<Button
									variant='outline'
									colorScheme='green'
									mr={3}
									onClick={e => {
										onClose(e)
									}}
									borderRadius='md'
									boxShadow='md'
									size='md'
								>
									{locale['Cancel']}
								</Button>
							</ModalFooter>
						</VStack>
					</HStack>
				</ModalBody>
			</ModalContent>
		</Modal>
	)
}

export default CardDetails
